import constants from "utils/constants";

export interface NavItem {
    path: string;
    name: string;
    url?: string | null;
    subItems?: NavItem[];
}

const defaultItems: NavItem[] = [
    {
        name: "tenantConfig.leftMenu.generalConfigurations",
        path: constants.routePath.generalConfig,
    },
    {
        name: "tenantConfig.leftMenu.erpConfigurations",
        path: constants.routePath.erpConfig,
    },
    {
        name: "tenantConfig.leftMenu.featureConfigurations",
        path: constants.routePath.featureConfig,
    },
    {
        name: "tenantConfig.leftMenu.dataImport",
        path: constants.routePath.dataImport,
    },
    {
        name: "tenantConfig.leftMenu.customFields",
        path: constants.routePath.dooapCustomFields,
        subItems: [
            {
                name: "tenantConfig.leftMenu.dooapCustomFields",
                path: constants.routePath.dooapCustomFields,
            },
            {
                name: "tenantConfig.leftMenu.erpCustomFields",
                path: constants.routePath.erpCustomFields,
            },
        ],
    },
    {
        name: "tenantConfig.leftMenu.studio",
        path: constants.routePath.studio,
    },
    {
        name: "tenantConfig.leftMenu.scheduler",
        path: constants.routePath.scheduler,
    },
    {
        name: "tenantConfig.leftMenu.regionalSettings",
        path: constants.routePath.cultureSettings,
    },
    {
        name: "tenantConfig.leftMenu.guestTenants",
        path: constants.routePath.guestTenants,
    },
    {
        name: "tenantConfig.leftMenu.subscriptions",
        path: constants.routePath.dopeSubscriptions,
    },
    {
        name: "tenantConfig.leftMenu.versionHistory",
        path: constants.routePath.versionHistory,
    },
    {
        name: "tenantConfig.leftMenu.dataRefreshHistory",
        path: constants.routePath.dataRefreshHistory,
    },
    {
        name: "tenantConfig.leftMenu.maintenanceMode",
        path: constants.routePath.maintenanceMode,
    },
    {
        name: "tenantConfig.leftMenu.mailboxManagement",
        path: constants.routePath.captureMailboxes,
    },
    {
        name: "tenantConfig.leftMenu.activityLog",
        path: constants.routePath.activityLog,
    },
];

export default defaultItems;

export const addUrl = (
    navItems: NavItem[],
    params: Record<string, string>
): NavItem[] => {
    const entries = Object.entries(params);

    const buildUrl = (path: string, entries: [string, string][]): string => {
        // Substitute :param placeholders first, since they aren't valid URL syntax
        return entries.reduce((result, [key, value]) => {
            return result.replace(`:${key}`, encodeURIComponent(value));
        }, path);
    };

    const add = (items: NavItem[]): NavItem[] =>
        items.map((item) => ({
            name: item.name,
            path: item.path,
            url: buildUrl(item.path, entries),
            ...(item.subItems?.length && { subItems: add(item.subItems) }),
        }));

    return add(navItems);
};

export const buildUrl = (path: string, entries: [string, string][]): string => {
    // Substitute :param placeholders first, since they aren't valid URL syntax
    return entries.reduce((result, [key, value]) => {
        return result.replace(`:${key}`, encodeURIComponent(value));
    }, path);
};
